<template>
  <header class="roles-header"
          v-if="projects">
    <div class="roles-header_left">
      <div v-if="isProjectPage" class="roles-path">
        <router-link class="link-to-roles" to="/roles">
          <chevron-icon fill="#109CF1"></chevron-icon>
          {{$t('menu.users')}}
        </router-link>
        <span>/</span>
        <p class="project-name">
          <trim-item :string="dirName"
                     :width="30"></trim-item>
        </p>
      </div>
      <div v-else class="title roles-path">
        {{$t('roles.allRoles')}}
      </div>
      <div v-if="displayedRolesInCell.length" @click="toggleAll" class="check-group">
        <checkAllIcon />
        <span class="check-number">{{checkedRolesSingle.length}}</span>
        <span class="check-action">
          {{checkedRolesSingle.length === displayedRolesInCell.length ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
      </div>
    </div>
    <nav class="projects-header_right">
      <ul class="controls-list view-controls">
        <li class="control-item view-control" v-if="checkedRolesSingle.length > 0">
          <button type="button"
                  @click="emitDel"
                  class="control-btn-new hover-blue-new hint-cont">
            <del-icon></del-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              {{$t('btns.users.delUser')}}
            </p>
          </button>
        </li>
        <li class="control-item view-control">
          <button type="button"
                  @click="showAddRole"
                  class="btn-main-plus hint-cont">
            <plus-icon></plus-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              {{$t('btns.users.user')}}
            </p>
          </button>

        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
  import delIcon from '../../Svg/cart_control/delIcon'
  import plusIcon from '../../Svg/plusIcon'
  import {mapMutations} from 'vuex'
  import {showOverlay} from "../../../mixins/utils/showOverlay"
  import chevronIcon from '../../Svg/chevronLeft'
  import {mapState} from 'vuex'
  import trimItem from '../../trimITem'
  import checkAllIcon from '../../Svg/projects/checkAllIcon'

  export default {
    name: 'rolesHeader',
    mixins: [showOverlay],
    components: {
      delIcon,
      plusIcon,
      chevronIcon,
      trimItem,
      checkAllIcon
    },
    computed: {
      ...mapState({
        dirName: state => state.roles.dirName,
        projects: state => state.projects.allProjects,
        checkedRolesSingle: state => state.roles.checkedRoles,
        displayedRolesInCell: state => state.roles.displayedRolesInCell,
      }),
      isProjectPage() {
        return this.$route.name !== 'roles'
      },
      checkedRolesAll: {
        get() {
          return this.checkedRolesSingle
        },
        set(val) {
          this.setCheckedRoles(val)
        }
      },
    },
    watch: {
      projects(val) {
        if (val) {
          this.findDirName();
        }
      }
    },
    methods: {
      ...mapMutations({
        addRolePopup: 'popups/addRole/SET_SHOW',
        setDirName: 'roles/SET_DIR_NAME',
        setCheckedRoles: 'roles/TOGGLE_CHECKED_ROLES'
      }),
      toggleAll() {
        if (this.checkedRolesSingle.length === this.displayedRolesInCell.length) {
          this.checkedRolesAll = []
        } else {
          this.checkedRolesAll = this.displayedRolesInCell
        }
      },
      showAddRole() {
        this.showOverlay(true);
        this.addRolePopup(true);
      },
      emitDel() {
        this.$emit('del')
      },
      findDirName() {
        let id = this.$route.params.id;

        for (let project of this.projects) {
          if (id == project.id) {
            this.setDirName(project.name);
            break;
          };

          let findInner = (item) => {
            if (item.items) {
              for (let inner of item.items) {
                if (inner.id == id) {
                  this.setDirName(inner.name);
                  break;
                  return
                }
                findInner(inner)
              }
            }
          };

          findInner(project)
        }
      }
    },
    mounted() {
      this.findDirName();
    }
  }
</script>

<style lang="scss" scoped>
  .roles-header {
    position: sticky;
    top: 90px;
    z-index: 1;
    background: $lightGrey;
    padding: 20px;
    box-shadow: inset 0px -1px 0px #D7E3EA;
    display: flex;
  }

  .roles-header_left {
    display: flex;
  }

  .check-group {
    min-width: 150px;
    height: 40px;
    border: 1px solid #109CF1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #109CF1;

    svg {
      margin-right: 10px;
      margin-left: 18px;
    }

    .check-number {
      margin-right: auto;
    }

    .check-action {
      cursor: pointer;
      margin: 0 18px;
    }
  }

  .projects-header_right {
    margin-left: auto;
  }

  .view-controls {

    display: flex;
    align-items: center;
    margin: 0 -10px;
  }

  .view-control {
    margin: 0 10px;
  }

  .roles-path {
    display: flex;
    align-items: center;
    margin-right: 40px;

    .link-to-roles {
      font-family: $msb;
      font-size: 16px;
      letter-spacing: .25px;
      color: $lightBlue;
      display: flex;
      align-items: center;

      svg {
        margin-right: 16px;
      }
    }

    span {
      font-family: $msb;
      font-size: 16px;
      color: $darkBlue;
      opacity: .30;
      margin: 0 20px;
    }

    .project-name {
      font-family: $msb;
      font-size: 16px;
      letter-spacing: .25px;
      color: $darkBlue;
      max-width: 40%;
    }
  }
</style>
